import { Component, OnInit, Input, OnChanges, SimpleChanges, DoCheck, OnDestroy, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
//Services
import { GamesService } from '../../../services/games.service';
import { ChallengesService } from '../../../services/challenges.service';
import { NavigationService } from 'src/app/navigation/navigation.service';
import { MarketplaceService } from '../../../services/marketplace.service';
import { ManualAwardsService } from '../../../services/manual-awards.service';
import { GamificationMainService } from '../../../services/gamification-main.service';
//Components
import { CoinsEarnedComponent } from '../modules/coins-earned/coins-earned.component';
import { CoinHistoryComponent } from '../modules/coin-history/coin-history.component';
import { BadgesEarnedComponent } from '../modules/badges-earned/badges-earned.component';
import { GamesRunningModalComponent } from '../modals/games-running-modal/games-running-modal.component';
import { CommandCenterOnboardingComponent } from '../modals/command-center-onboarding/command-center-onboarding.component';
import { MarketplaceOrdersModalComponent } from '../modals/marketplace-orders-modal/marketplace-orders-modal.component';
@Component({
    selector: 'cv-command-center',
    templateUrl: './command-center.component.html',
    styleUrls: ['./command-center.component.scss']
})
export class CommandCenterComponent implements OnInit, OnChanges, DoCheck, OnDestroy {
    @Input() inputData: any;  //AngularJS factory data object is received to update Angular service
    @Output() areasChanged: EventEmitter<any> = new EventEmitter<any>();              //Send change on visible areas to AngularJS factory
    @Output() settingsSaved: EventEmitter<void> = new EventEmitter<void>();           //Send settings saved to AngularJS factory
    @Output() overviewdateChanged: EventEmitter<string> = new EventEmitter<string>(); //Send overviewDate to AngularJS factory

    @ViewChild('selectorContainer') el: ElementRef;
    @ViewChild(CoinHistoryComponent) coinHistoryComponent: CoinHistoryComponent;
    @ViewChild(CoinsEarnedComponent) coinsEarnedComponent: CoinsEarnedComponent;
    @ViewChild(BadgesEarnedComponent) badgesEarnedComponent: BadgesEarnedComponent;

    gs: any = null;
    cs: any = null;
    ms: any = null;
    mas: any = null;
    gms: any = null;

    showFilter = false;
    loadTimeout: any = false;
    glimpseLoaded = false;

    //Implemented for AngularJs factory and Angular service communication
    //Will be readjusted when gamification landing page is migrated to pure angular 
    isInputDataLoaded: boolean = false;
    prevHiddenAreas = null;
    prevOverview = null;

    constructor(
        private modalService: NgbModal,
        private gamesService: GamesService,
        private challengesService: ChallengesService,
        private navigationService: NavigationService,
        private marketplaceService: MarketplaceService,
        private manualAwardsService: ManualAwardsService,
        private gamificationMainService: GamificationMainService
    ) {
        this.gs = gamesService.data;
        this.cs = challengesService.data;
        this.ms = marketplaceService.data;
        this.mas = manualAwardsService.data;
        this.gms = gamificationMainService.data;

        $(document).on('event_SelectedGroupsChanged', this.onGroupsChangedHandler);
    }

    ngOnInit(): void {
        this.gs.loadGlimpseOverview = true;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!this.isInputDataLoaded) {
            if (changes.inputData && changes.inputData.currentValue != changes.inputData.previousValue) {
                this.gms = changes.inputData.currentValue;

                if (!this.gms.settings.OnboardingComplete) {
                    this.openSettings();
                }

                this.loadGlimpse();
                this.marketplaceService.loadProducts(null);
                this.manualAwardsService.loadManualAwards();

                this.isInputDataLoaded = true;
            }
        }
    }

    ngDoCheck(): void {
        if (this.prevHiddenAreas != this.gms.settings.HiddenAreas && this.isInputDataLoaded) {
            this.updateHiddenAreas(this.gms.settings.HiddenAreas);
            this.prevHiddenAreas = this.gms.settings.HiddenAreas;
        }

        if (this.prevOverview != this.gms.settings.OverviewDate && this.isInputDataLoaded) {
            this.prevOverview = this.gms.settings.OverviewDate;
            // If settings are not loaded yet, we don't want to save
            if (!this.gms.settingsLoaded) {
                return;
            }

            // Select value is already saved
            if (this.gms.savedSettings.OverviewDate === this.gms.settings.OverviewDate) {
                return;
            }

            this.gamificationMainService.saveSettings(this.gms.settings);
        }
    }

    ngOnDestroy(): void {
        this.gs.loadGlimpseOverview = false;

        if (this.gs.loadTimeout && !this.gs.loadGlimpseOverview && !this.gs.loadGlimpseGamesLanding) {
            clearTimeout(this.gs.loadTimeout);
            this.gs.loadTimeout = null;
        }

        $(document).off('event_SelectedGroupsChanged', this.onGroupsChangedHandler);
    }

    updateHiddenAreas(array: string[]): void {
        // figure out which glimpses are available to view
        var glimpseAreas = ["Currency", "Games", "Challenges", "Awards"];
        var availableTabs = this.gms.availableTabs.map((t) => { return t.name });

        this.gms.visibleAreas = availableTabs.reduce((visibleAreas, area) => {
            visibleAreas[area] = array.indexOf(area) < 0;
            return visibleAreas;
        }, {});

        var shownGlimpseAreas = glimpseAreas.filter((area) => {
            return this.gms.visibleAreas[area];
        });

        // glimpse width
        switch (shownGlimpseAreas.length) {
            case 0:
                this.gms.glimpseSize = '';
                break;
            case 1:
                this.gms.glimpseSize = 'col-12';
                break;
            case 2:
                this.gms.glimpseSize = 'col-12 col-md-6';
                break;
            case 3:
                this.gms.glimpseSize = 'col-12 col-md-6 col-lg-4';
                break;
            case 4:
                this.gms.glimpseSize = 'col-12 col-md-6 col-lg-6 col-xl-3';
                break;
        }

        this.isInputDataLoaded = false;
        this.areasChanged.emit(this.gms.visibleAreas);
    }

    async loadGlimpse() {
        let failed: boolean = false;
        let promises: Promise<any>[] = [];
        promises.push(this.gamesService.loadGamesLanding(false));
        promises.push(this.marketplaceService.loadProducts(true));
        promises.push(this.challengesService.loadRunningChallenges());
        promises.push(this.marketplaceService.loadMarketplaceOrders());
        promises.push(this.manualAwardsService.loadAllManualAwardHistory());

        await Promise.all(promises).catch(() => { failed = true });
        if (!failed) {
            if (this.gs.loadTimeout === null && !this.gs.loadGlimpseOverview && !this.gs.loadGlimpseGamesLanding) {// Timeout destroyed - don't start a new one
                return;
            }

            this.glimpseLoaded = true;
            this.gs.loadTimeout = setTimeout(() => {
                this.loadGlimpse();
            }, 60000);
        }
    }

    openSettings(): void {
        this.navigationService.showOverlay = true;
        const modalRef = this.modalService.open(CommandCenterOnboardingComponent, {
            animation: true,
            backdropClass: 'stopScrolling',
            size: 'md modal-dialog-noborder-when-loading modal-dialog-centered'
        });

        modalRef.componentInstance.inputData = this.gms;

        modalRef.componentInstance.areaChanged.subscribe((newData) => {
            this.updateHiddenAreas(newData);
        });

        modalRef.result.finally(() => {
            this.navigationService.showOverlay = false;
        });
    }

    openMarketplaceModal(): void {
        this.navigationService.showOverlay = true;

        const modalRef = this.modalService.open(MarketplaceOrdersModalComponent, {
            animation: true,
            backdropClass: 'stopScrolling',
            size: 'lg modal-dialog-noborder-when-loading modal-dialog-centered'
        });

        modalRef.result.finally(() => {
            this.navigationService.showOverlay = false;
        });
    }

    openGamesModal(): void {
        this.navigationService.showOverlay = true;

        const modalRef = this.modalService.open(GamesRunningModalComponent, {
            animation: true,
            backdropClass: 'stopScrolling',
            size: 'lg modal-dialog-noborder-when-loading modal-dialog-centered'
        });

        modalRef.result.finally(() => {
            this.navigationService.showOverlay = false;
        });
    }

    onGroupsChanged(e: any): void {
        if (e.pageName !== "GamificationSettings*e") {
            return;
        }

        // Load logins
        this.gamificationMainService.loadGroupSelectorLogins().then(() => {
            // Global command center groups changed functions
            this.marketplaceService.filterMarketplaceOrders();
        });
    }

    setOverviewDate(value: string): void {
        if (!this.gms.settingsLoaded) {
            return;
        }

        // selected value is already saved
        if (this.gms.savedSettings.OverviewDate === value) {
            return;
        } else {
            this.gms.settings.OverviewDate = value;
            this.gamificationMainService.saveSettings(this.gms.settings);

            this.isInputDataLoaded = false;
            this.overviewdateChanged.emit(this.gms.settings.OverviewDate);
            this.settingsSaved.emit();
        }
    }

    getButtonClass(value: string): string {
        return (this.gms.settings.OverviewDate == value) ? 'active' : '';
    }

    private onGroupsChangedHandler = (e: any) => this.onGroupsChanged(e);

    saveSettingsForFactory(): void {
        //Updating angularJS factory data object
        this.settingsSaved.emit();
    }
}